// extracted by mini-css-extract-plugin
export default {"root":"OrgListNavigation_root__B+f3V","nav":"OrgListNavigation_nav__yUOxX","placeHolderShimmer":"OrgListNavigation_placeHolderShimmer__Dx3nN"};